import React from 'react';
import './App.css';
import 'antd/dist/antd.css';

import Header from "./Header/Header";
import LeftToolbar from "./LeftToolbar/LeftToolbar";
import GraphContainer from "./GraphContainer/GraphContainer";
import RightToolbar from "./RightToolbar/RightToolbar";
import Footer from "./Footer/Footer";
import {Drawer} from 'antd';
import {connect} from "react-redux";
import ActionBtn from "./Components/Buttons/ActionBtn/ActionBtn";
import {FeedbackForm} from './Components/Feedback_Form/FeedbackForm';
import {
    setLoader,
    removeLoader,
    setSchematicDocument,
    setSidebarVisibility,
    setSymbolTypes,
    setDraft,
    setBackgrounds,
    setActiveSchematicType
} from '../store/Schematic_store/actions'
import LocalStorageService from "../localStorage-service";
import AutoSave from './Components/AutoSave/AutoSave';
import ApiService from "./services/APIService";


class App extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            visibleFeedbackModal: false,
        };
    }

    recreateSchemaAfterReload = () => {
        const {setSchematicDocument, setLoader, removeLoader} = this.props;
        setLoader('Recreating schema...');
        const id = LocalStorageService.getSchematicId();
        ApiService.getSchematic(id).then(res => {
            const {document_name, data} = res;
            setSchematicDocument({document_name, data});
            removeLoader('Recreating schema...');
        }).catch(() => removeLoader('Recreating schema...'));
    }

    componentDidMount() {
        const {history, setLoader, removeLoader, setSymbolTypes, setBackgrounds, setActiveSchematicType} = this.props;
        const schematic_type_id = LocalStorageService.getSchematicTypeId();
        if (schematic_type_id) {
            setLoader('Fetching symbols...');
            Promise.all([ApiService.getTypesSymbols(schematic_type_id), ApiService.getBackgrounds(), ApiService.getActiveSchematicType(schematic_type_id)]).then(response => {
                const [types, newBackgrounds, activeSchematicType] = response;
                setSymbolTypes(types);
                setBackgrounds(newBackgrounds);
                setActiveSchematicType(activeSchematicType);
                removeLoader('Fetching symbols...');
                const id = LocalStorageService.getSchematicId();
                if (id) {
                    this.recreateSchemaAfterReload();
                }
            }).catch(() => removeLoader('Fetching symbols...'));
        } else {
            history.push('/account/projects');
        }


    }

    componentWillUnmount() {
        const {setSidebarVisibility, sidebarVisible} = this.props;
        if (sidebarVisible) setSidebarVisibility(false);
    }

    showDrawer = () => {
        const {setSidebarVisibility} = this.props;
        setSidebarVisibility(true)
    };

    onClose = () => {
        const {setSidebarVisibility} = this.props;
        setSidebarVisibility(false)
    };

    render() {
        const {visibleFeedbackModal} = this.state;
        const {sidebarVisible} = this.props;
        return (
            <div className={"page"}>
                <AutoSave>
                    <Header/>
                    <div className="body_container" onContextMenu={(e)=> e.preventDefault()}>
                        <LeftToolbar/>
                        <GraphContainer/>
                        <ActionBtn position={{bottom: "160px", right: "30px"}} iconName={"plus"}
                                   handleClick={this.showDrawer}
                                   title={'Schematics Library'}/>
                        <ActionBtn position={{bottom: "100px", right: "30px"}} iconName={"message"}
                                   handleClick={() => {
                                       this.setState({visibleFeedbackModal: true});
                                   }} title={'Leave Feedback'}/>

                        <FeedbackForm onClose={() => {
                            this.setState({visibleFeedbackModal: false});
                        }} visible={visibleFeedbackModal}/>
                        <Drawer
                            title="Schematics Library"
                            width={400}
                            mask={false}
                            bodyStyle={{padding: 0}}
                            placement="right"
                            closable={true}
                            onClose={this.onClose}
                            visible={sidebarVisible}
                            drawerStyle={{
                                borderLeft: "1px solid #AAAAAA",
                                backgroundColor: "rgb(250 250 250)"
                            }}
                        >
                            <RightToolbar/>
                        </Drawer>
                    </div>
                    <Footer/>
                </AutoSave>
            </div>
        );
    }
}

function mapStateToProps({schematicReducers: {previewSymbol, sidebarVisible, symbolsTypes, schematicDocument, loading}}) {
    return {
        previewSymbol,
        symbolsTypes,
        sidebarVisible,
        schematicDocument,
        loading
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setSidebarVisibility: (value) => {
            dispatch(setSidebarVisibility(value))
        },
        setSchematicDocument: (schematicDocument) => {
            dispatch(setSchematicDocument(schematicDocument))
        },
        setLoader: (loader) => {
            dispatch(setLoader(loader))
        },
        removeLoader: (loader) => {
            dispatch(removeLoader(loader))
        },
        setSymbolTypes: (symbolTypes) => {
            dispatch(setSymbolTypes(symbolTypes))
        },
        setDraft: (draft) => {
            dispatch(setDraft(draft))
        },
        setBackgrounds: (backgrounds) => {
            dispatch(setBackgrounds(backgrounds))
        },
        setActiveSchematicType: (activeSchematicType) => {
            dispatch(setActiveSchematicType(activeSchematicType))
        }
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(App);
